/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAdmission } from 'app/shared/model/admission.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { DischargeType } from 'app/shared/model/enumerations/discharge-type.model';
import { DischargeStatus } from 'app/shared/model/enumerations/discharge-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IDischargeSummary {
  id?: string;
  summaryoftreatment?: string | null;
  admissiondiagnosis?: string | null;
  finaldiagnosis?: string | null;
  previousmedicines?: string | null;
  treatementmedicines?: string | null;
  emergencyPlan?: string | null;
  nextVisit?: number;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  dischargeType?: keyof typeof DischargeType | null;
  dischargeStatus?: keyof typeof DischargeStatus | null;
  sourceOfHistory?: string | null;
  chiefComplaints?: string | null;
  historyOfPresentIllness?: string | null;
  medicalHistory?: string | null;
  familyHistory?: string | null;
  historyOfAllergies?: string | null;
  historyOfImmunization?: string | null;
  systemicExamination?: string | null;
  discussion?: string | null;
  dietInstructions?: string | null;
  followupInstructions?: string | null;
  physicalActivityInstructions?: string | null;
  normalcyAfter?: number;
  surgicalWoundClear?: string | null;
  painScore?: string | null;
  vitalsStable?: boolean;
  ambulatory?: boolean;
  intiitiatedById?: string | null;
  modifiedById?: string | null;
  intiitiatedByType?: keyof typeof AddedByType | null;
  modifiedByType?: keyof typeof AddedByType | null;
  admission?: IAdmission | null;
  patient?: IGlucoUser;
  prescription?: IPrescription | null;
  approvedBy?: IDoctor | null;
}

export const defaultValue: Readonly<IDischargeSummary> = {
  active: false,
  vitalsStable: false,
  ambulatory: false,
};
